import { request } from '../../../gateways/api'
import type { LinkedProjects } from '../types/LinkedProjects'

export { fetchLinkedProjectsForEntity }

const fetchLinkedProjectsForEntity = async (entityId: string) => {
  const linkedProjectsResult = await request<LinkedProjects>({
    url: `/rest/project/${entityId}/koppelingen`,
  })

  return linkedProjectsResult
}
